import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './AndroidTechnologies.css';

const technologies = {
  "Languages": [
    { 
      name: "Kotlin",
      logo: "/assets/tech-logos/kotlin-external.png",
      fallbackLogo: "/assets/tech-logos/kotlin.svg"
    },
    { 
      name: "Java",
      logo: "/assets/tech-logos/java-external.svg",
      fallbackLogo: "/assets/tech-logos/java.svg"
    }
  ],
  "Frameworks": [
    { 
      name: "Android SDK",
      logo: "/assets/tech-logos/android.svg",
      fallbackLogo: "/assets/tech-logos/android.svg"
    },
    { 
      name: "Jetpack Compose",
      logo: "/assets/tech-logos/jetpack.svg",
      fallbackLogo: "/assets/tech-logos/jetpack.svg"
    },
    { 
      name: "Flutter",
      logo: "/assets/tech-logos/flutter-external.svg",
      fallbackLogo: "/assets/tech-logos/flutter.svg"
    },
    { 
      name: "React Native",
      logo: "/assets/tech-logos/react-external.svg",
      fallbackLogo: "/assets/tech-logos/react.svg"
    }
  ],
  // "Architecture": [
  //   { 
  //     name: "MVVM",
  //     logo: "/assets/tech-logos/mvvm-external.png",
  //     fallbackLogo: "/assets/tech-logos/mvvm.svg"
  //   },
  //   { 
  //     name: "MVC",
  //     logo: "/assets/tech-logos/mvc-external.svg",
  //     fallbackLogo: "/assets/tech-logos/mvc.svg"
  //   },
  //   { 
  //     name: "MVP",
  //     logo: "/assets/tech-logos/mvp-external.png",
  //     fallbackLogo: "/assets/tech-logos/mvp.svg"
  //   }
  // ],
  "Database": [
    { 
      name: "SQLite",
      logo: "/assets/tech-logos/sqlite-external.svg",
      fallbackLogo: "/assets/tech-logos/sqlite.svg"
    },
    {
      name: "MongoDB",
      logo: "/assets/tech-logos/mongodb.png",
      fallbackLogo: "/assets/tech-logos/mongodb.svg"
    },
    {
      name: "MySQL",
      logo: "/assets/tech-logos/mysql.png",
      fallbackLogo: "/assets/tech-logos/mysql.svg"
    }

  ],
  "Development Tools": [
    { 
      name: "Android Studio",
      logo: "/assets/tech-logos/androidstudio-external.png",
      fallbackLogo: "/assets/tech-logos/androidstudio.svg"
    },
    { 
      name: "Gradle",
      logo: "/assets/tech-logos/gradle-external.png",
      fallbackLogo: "/assets/tech-logos/gradle.svg"
    },
    { 
      name: "Firebase",
      logo: "/assets/tech-logos/firebase-external.svg",
      fallbackLogo: "/assets/tech-logos/firebase.svg"
    }
  ]
};

const AndroidTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const handleImageError = (e, fallbackSrc) => {
    if (e.target.src !== fallbackSrc) {
      e.target.src = fallbackSrc;
    }
  };

  return (
    <Box className="android-technologies-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            ANDROID
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                          onError={(e) => handleImageError(e, tech.fallbackLogo)}
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default AndroidTechnologies; 